export default "__VITE_ASSET__CLk3jOnK__"